import { render, staticRenderFns } from "./agentReceiving.vue?vue&type=template&id=56b77de8&scoped=true&"
import script from "./agentReceiving.vue?vue&type=script&lang=js&"
export * from "./agentReceiving.vue?vue&type=script&lang=js&"
import style0 from "./agentReceiving.vue?vue&type=style&index=0&id=56b77de8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b77de8",
  null
  
)

export default component.exports